<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <admin-breadcrumb name="Brands"/>
    <b-row>
      <b-col cols="12">
        <admin-panel title="Users" sub-title="Manage all brands created in GreenLists">
          <admin-brands-table :brands="brands" @approve="approveBrand" @delete="deleteBrand"/>
          <template v-slot:header-right>
            <b-form-select
                class="w-auto ml-2"
                v-model="filters.status"
                :options="statusOptions"
                @change="loadBrands"
            />
          </template>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {API_ROUTES} from "../api";
import AdminPanel from "../components/AdminPanel";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import AdminPreloader from "../components/AdminPreloader";
import AdminBrandsTable from "../components/AdminBrandsTable";

export default {
  name: "AdminBrands",
  components: {AdminBrandsTable, AdminPreloader, AdminBreadcrumb, AdminPanel},
  data() {
    return {
      brands: [],
      loading: true,
      filters: {
        status: ''
      },
      statusOptions: [
        {
          text: 'All Statuses',
          value: ''
        },
        {
          text: 'Approved',
          value: 1
        },
        {
          text: 'Not Approved',
          value: 0
        }
      ]
    }
  },
  computed: {
    canApproveBrands() {
      return this.$store.getters['auth/hasAdminPermissions']('brand_approve');
    },
    canDeleteBrands() {
      return this.$store.getters['auth/hasAdminPermissions']('brand_delete');
    },
    search() {
      return this.$store.state.current.search;
    },
  },
  methods: {
    checkPermission(permission) {
      if (!this[permission]) {
        this.$bvToast.toast('Sorry! You don\'t have permission to do this action', {
          title: 'Denied!',
          variant: 'danger'
        });
        return false;
      }
      return true;
    },
    loadBrands() {
      this.loading = true;
      let params = {};
      if (this.search) {
        params['search'] = this.search;
      }
      if (this.filters.status !== '') {
        params['is_approved'] = this.filters.status;
      }
      this.$api.get(API_ROUTES.ADMIN_TAXONOMY_BRANDS, {
        params: params
      }).then(({data}) => {
        this.brands = data.brands;
      }).catch(({response}) => {

      }).finally(() => this.loading = false);
    },
    approveBrand(brand) {
      if (!this.checkPermission('canApproveBrands')) {
        return;
      }
      this.$bvModal.msgBoxConfirm(`You are going to approve brand: ${brand.name}`, {
        title: 'Please confirm',
        okVariant: 'success',
        centered: true
      }).then(value => {
        if (value) {
          this.loading = true;
          this.$api.post(`${API_ROUTES.ADMIN_TAXONOMY_BRANDS}/${brand.id}`, {is_approved: true}).then(({data}) => {
            let index = this.brands.findIndex(b => b.id === brand.id);
            if (index >= 0) {
              let brands = [...this.brands];
              brands[index] = data.brand;
              this.brands = brands;
            }
            this.$bvToast.toast('Brand has been successfully approved', {
              title: 'Success!',
              variant: 'success'
            });
          }).catch(({response: {data}}) => {
            this.$bvToast.toast(data.message ?? 'Failed to process operation', {
              variant: 'danger',
              title: 'Error!'
            });
          }).finally(() => this.loading = false);
        }
      });
    },
    deleteBrand(brand) {
      if (!this.checkPermission('canDeleteBrands')) {
        return;
      }
      this.$bvModal.msgBoxConfirm(`You are going to delete brand: ${brand.name}`, {
        title: 'Please confirm',
        okVariant: 'success',
        centered: true
      }).then(value => {
        if (value) {
          this.loading = true;
          this.$api.post(`${API_ROUTES.ADMIN_TAXONOMY_BRANDS}/${brand.id}`, {is_approved: false}).then(({data}) => {
            this.brands = this.brands.filter(b => b.id !== brand.id);
            this.$bvToast.toast('User has been successfully deleted', {
              title: 'Success!',
              variant: 'success'
            });
          }).catch(({response: {data}}) => {
            this.$bvToast.toast(data.message ?? 'Failed to process operation', {
              variant: 'danger',
              title: 'Error!'
            });
          }).finally(() => this.loading = false);
        }
      });
    }
  },
  created() {
    this.loadBrands();
  }
}
</script>
